// extracted by mini-css-extract-plugin
module.exports = {"back_button":"BackButton_back_button__3AOKO"};